<template>
  <div class="main-container" :style="{padding:'25px 0'}">
    <Bread/>
    <SecondNav/>
    <router-view/>
  </div>
</template>
<script>
/* 二级路由共用模板页 */
import SecondNav from "@/components/secondNav";
import Bread from '@/components/bread'
export default {
  components:{Bread,SecondNav},
};
</script>